<template>
  <v-card>
    <v-card-title>空フォーム</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="4">
            <set-Cols
              :value="String(returnData.cols)"
              v-on:set="$set(returnData, 'cols', $event)"
            ></set-Cols>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
  },
  props: {
    label: String,
    type: Number,
    cols: String,
    position: Number,
    //個別値
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
      },
      varidation: {
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      //個別値
    };
  },
  mounted() {
    console.log("returnData", this.returnData);
  },
  methods: {
    submit() {
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
